var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { usePortal } from "../hooks/usePortal";
import { useCallbackRef } from "../hooks/useRef";
export function IFrame(_a) {
    var _b;
    var { children, getMountNode = (window) => { var _a; return (_a = window === null || window === void 0 ? void 0 : window.document) === null || _a === void 0 ? void 0 : _a.body; } } = _a, props = __rest(_a, ["children", "getMountNode"]);
    const [iframe, ref] = useCallbackRef();
    const mountNode = getMountNode((_b = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) !== null && _b !== void 0 ? _b : undefined);
    const portal = usePortal({ source: children, target: mountNode });
    return (React.createElement("iframe", Object.assign({}, props, { ref: ref }), portal));
}
